import { useState } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { makeApi, aiErrorText, coinToast } from "@/lib/api";

const LIMIT_MSG = {
  es: "Usaste tus 5 imágenes gratis de hoy. Vuelve mañana o pide a tus papás el Plan Familia.",
  en: "You used your 5 free images today. Come back tomorrow or ask your parents for the Family Plan.",
};

export default function useImageGen(errorText, lang = "es") {
  const { getToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const generate = async (prompt, image, kind, caption) => {
    setLoading(true);
    try {
      const r = await makeApi(getToken).post("/ailab/image", { prompt, image, kind, caption }, { timeout: 120000 });
      coinToast(r.data.coins_awarded, lang);
      return r.data.image;
    } catch (e) {
      toast.error(e.response?.status === 402 ? LIMIT_MSG[lang] : aiErrorText(e, lang, errorText));
      return null;
    } finally {
      setLoading(false);
      window.dispatchEvent(new Event("ailab-usage"));
    }
  };
  return { generate, loading };
}

export const fileToDataUrl = (file) =>
  new Promise((resolve) => {
    const img = new window.Image();
    img.onload = () => {
      const scale = Math.min(1, 1024 / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = img.width * scale;
      c.height = img.height * scale;
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      resolve(c.toDataURL("image/jpeg", 0.85));
    };
    img.src = URL.createObjectURL(file);
  });
